import CounterBox from 'components/Common/CounterBox'
import Input from 'components/Common/Input'
import MultiSelectBox from 'components/Common/MultiSelectBox'
import Range from 'components/Common/Range'
import SelectBox from 'components/Common/SelectBox'
import Spinner from 'components/Common/Spinner'
import TextEditor from 'components/Common/TextEditor'
import ImportantPriorityIcon from 'components/Icons/tasks/importantPriority'
import LowPriorityIcon from 'components/Icons/tasks/lowPriority'
import MediumPriorityIcon from 'components/Icons/tasks/mediumPriority'
import UrgentPriorityIcon from 'components/Icons/tasks/urgentPriority'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useLazyGetProjectContactsApiQuery } from 'redux/api/contact_api'
import { useLazyGetAllMilestoneByProjectIdApiQuery } from 'redux/api/milestone_api'
import { useGetProjectsByOrgIdApiQuery } from 'redux/api/projects_api'
import { useLazyGetTaskByMilestoneApiQuery } from 'redux/api/task_api'
import { UpdateTaskApi } from 'services/dashboardServices/task'
import { LabelAndValueHandler } from 'utils/LabelAndValueHandler'
import { useConfig } from 'config/ConfigContext'

const SubTaskDetailEditBox = ({ data, updateList, modalHandler }) => {
	const { data: projects, isLoading: projectLoading } =
		useGetProjectsByOrgIdApiQuery()
	const [getMilestones, { data: milestones, isLoading: milestoneLoading }] =
		useLazyGetAllMilestoneByProjectIdApiQuery()
	const [getContacts, { data: contacts, isLoading: contactsLoading }] =
		useLazyGetProjectContactsApiQuery()
	const [getTasks, { data: tasks, isLoading: tasksLoading }] =
		useLazyGetTaskByMilestoneApiQuery()
	const navigate = useNavigate()
	const [errors, setErrors] = useState()
	const [isLoading, setIsLoading] = useState(null)
	const config = useConfig()

	const taskPriorities = [
		{ id: 1, label: 'low', icon: <LowPriorityIcon /> },
		{ id: 2, label: 'medium', icon: <MediumPriorityIcon /> },
		{ id: 3, label: 'important', icon: <ImportantPriorityIcon /> },
		{ id: 4, label: 'urgent', icon: <UrgentPriorityIcon /> }
	]
	const taskTypes = [
		{ id: 1, label: 'Task' },
		{ id: 2, label: 'QA' },
		{ id: 3, label: 'Story' },
		{ id: 4, label: 'BUG' },
		{ id: 5, label: 'Hotfix' }
	]

	const [dataSchema, setDataSchema] = useState({
		id: null,
		name: null,
		description: null,
		project_id: null,
		milestone_id: null,
		due_date: null,
		time_budget: 0,
		team_id: null,
		priority: taskPriorities[1],
		parent_id: null,
		status: null,
		type: taskTypes[0]
	})

	useEffect(() => {
		if (data) {
			setTimeout(() => {
				setDataSchema({
					id: data?.id,
					name: data?.name,
					description: data?.description,
					project_id: data?.project?.id,
					milestone_id: data?.milestone?.id,
					due_date: data?.due_date,
					time_budget: data?.time_budget ? data?.time_budget?.split(':')[0] : 0,
					team_id: data?.teams?.map(item => ({
						...item,
						id: item.team_id,
						value: item.team_id,
						label: `${item.first_name} ${item.last_name}`
					})),
					priority: data?.priority,
					type: data?.type,
					parent_id: LabelAndValueHandler(data, 'parent_id'),
					status: null
				})
				getMilestones({ projectId: data?.project?.id })
				getContacts({ projectId: data?.project?.id })
				getTasks(data?.milestone?.id)
			}, 300)
		}
	}, [data])

	const updateTask = async e => {
		e.preventDefault()
		setIsLoading(true)
		const newDataDataSchema = {
			...dataSchema,
			parent_id: dataSchema?.parent_id?.id,
			team_ids: dataSchema?.team_id?.map(item => item?.id),
			priority: dataSchema?.priority,
			type: dataSchema?.type
		}
		try {
			let response = await UpdateTaskApi(navigate, newDataDataSchema)
			if (response.status === 200) {
				toast.success('Task successfully Updated')
				await updateList()
				modalHandler()
			} else if (response.status === 422) {
				setErrors(response.data.errors)
			}
			setIsLoading(false)
		} catch (error) {
			setIsLoading(false)
			console.error(error)
		}
	}

	const dataSchemaHandler = (_key, _value) => {
		_value = _key === 'priority' || _key === 'type' ? _value?.label : _value
		setDataSchema({ ...dataSchema, [_key]: _value })

		if (errors && errors[_key]) {
			const data = errors
			delete data[_key]
			setDataSchema(data)
		}
	}

	return (
		<div className=''>
			<form onSubmit={updateTask}>
				<div className='grid grid-cols-2 gap-5'>
					<Input
						label={'SubTask Name'}
						height={50}
						name='name'
						value={dataSchema.name}
						onInput={dataSchemaHandler}
						placeholder='Enter SubTask Name'
						errors={errors?.name}
					/>
					<SelectBox
						isLoading={!data?.project && projectLoading ? true : false}
						onChange={e => {
							dataSchemaHandler('project_id', e.id)
							e?.id && getMilestones({ projectId: e.id })
							setTimeout(() => [dataSchemaHandler('milestone_id', null), 500])
						}}
						value={
							data?.project && !projects
								? { value: data?.project?.id, label: data?.project?.name }
								: dataSchema.project_id
								? projects.find(item => item.id === dataSchema.project_id)
								: ''
						}
						options={projects}
						placeholder={`Search ${config?.use_case_name}`}
						height={50}
						errors={errors?.project_id}
						label={`Select ${config?.use_case_name}`}
						isDisabled={!projects}
						name={'project_id'}
						grayBg
						withSearchIcon
					/>
				</div>
				<div className='grid grid-cols-2 gap-5 mt-5'>
					<div className='flex flex-col gap-5'>
						{!dataSchema?.description ||
						dataSchema?.description?.includes('<') ? (
							<TextEditor
								mode='advanced'
								label={'SubTask Description'}
								height={252}
								onChange={dataSchemaHandler}
								name='description'
								errors={errors?.description}
								value={dataSchema.description}
							/>
						) : (
							<Input
								type={'textarea'}
								label={'SubTask Description'}
								height={144}
								name='description'
								onInput={dataSchemaHandler}
								placeholder='Describe your Subtask'
								errors={errors?.description}
								value={dataSchema.description}
							/>
						)}
						<MultiSelectBox
							name={'team_id'}
							onChange={dataSchemaHandler}
							isDisabled={tasksLoading}
							value={dataSchema?.team_id}
							errors={errors?.team_id}
							options={contacts?.filter(
								item =>
									!item.role.name.includes('Accountant') &&
									!item.role.name.includes('Client')
							)}
							placeholder={'Search Contact'}
							height={50}
							label={'Assign To'}
						/>
						{/* <div>
							<label className='font-light flex text-gray-700 text-sm mb-0.5'>
								Assign To
							</label>
							<div className='h-[50px]  custom_select_box'>
								<ReactSelect
									options={contacts}
									isMulti={true}
									isDisabled={tasksLoading}
									onChange={e => dataSchemaHandler('team_id', e)}
									value={dataSchema?.team_id}
									placeholder='Search Team'
								/>
							</div>
						</div> */}
					</div>
					<div className='task_select_box  flex flex-col gap-5'>
						<SelectBox
							isLoading={!data?.project && milestoneLoading ? true : false}
							onChange={(_, e) => dataSchemaHandler('milestone_id', e.id)}
							options={milestones}
							placeholder='Search milestone'
							value={
								data?.milestone && !milestones
									? {
											value: data?.milestone?.id,
											label: data?.milestone?.name
									  }
									: dataSchema.milestone_id
									? milestones.find(item => item.id === dataSchema.milestone_id)
									: ''
							}
							isDisabled={true}
							height={50}
							errors={errors?.milestone_id}
							label={'Select Milestone'}
							name={'milestone_id'}
							grayBg
						/>
						<SelectBox
							isLoading={!data?.project && milestoneLoading ? true : false}
							onChange={dataSchemaHandler}
							options={tasks}
							placeholder='Search Task'
							value={dataSchema?.parent_id}
							isDisabled={!tasks}
							height={50}
							errors={errors?.parent_id}
							label={'Select Task'}
							name={'parent_id'}
							grayBg
						/>
						<Input
							type={'date'}
							label={'Due Date'}
							height={50}
							name='due_date'
							onInput={dataSchemaHandler}
							placeholder='Choose from Calendar'
							errors={errors?.due_date}
							defaultValue={dataSchema.due_date}
							format='YYYY-MM-DD'
						/>

						<CounterBox
							handler={dataSchemaHandler}
							label={'Subtask Time Budget'}
							name={'time_budget'}
							placeholder={'Subtask Time Budget'}
							height={50}
							value={dataSchema?.time_budget}
						/>
						{/* <Range
							label={'Subtask Priority'}
							name={'priority'}
							onChange={dataSchemaHandler}
							value={dataSchema.priority}
						/> */}
						<div className='flex items-center gap-5 w-full'>
							<SelectBox
								height={50}
								containerClassName={'w-full'}
								errors={errors?.priority}
								label={'Select Task Priority'}
								onChange={dataSchemaHandler}
								options={taskPriorities}
								value={
									taskPriorities.filter(
										item => item.label === dataSchema.priority
									)[0]
								}
								name={'priority'}
								grayBg
							/>
							<SelectBox
								height={50}
								containerClassName={'w-full'}
								errors={errors?.type}
								label={'Select Task Type'}
								onChange={dataSchemaHandler}
								options={taskTypes}
								value={
									taskTypes.filter(item => item.label === dataSchema.type)[0]
								}
								name={'type'}
								grayBg
							/>
						</div>
					</div>
				</div>

				<div className='grid mt-24 gap-5'>
					<button
						disabled={isLoading}
						name='close'
						type='submit'
						className={`h-11 rounded-[10px] flex items-center justify-center gap-3 border border-solid bg-primaryBlue text-white text-center text-base font-medium${
							!isLoading && 'border-primaryBlue'
						}`}>
						Update
						<Spinner show={isLoading} scale={25} />
					</button>
				</div>
			</form>
		</div>
	)
}

export default SubTaskDetailEditBox
